import { useParams } from "react-router-dom";
import { ArtistNotFound } from "features/layouts";
import { ReviewableTemplatePlaceholder, useArtist } from "features/reviewable";
import { ArtistProfileTemplate } from "features/artistProfile";
import { SiteContainer } from "atoms";
import { ApiError } from "utils/api";

// FOR EXAMPLE:
//   http://localhost:3001/artists/alba-m-torregrossa
//   http://localhost:3001/artists/riska-holakanola

function ArtistProfile() {
  const { artistId } = useParams<{ artistId: string }>();
  const query = useArtist(artistId);

  if (
    query.data &&
    (query.data.status === "PUBLISHED" || query.data.status === "DRAFT")
  ) {
    return <ArtistProfileTemplate artist={query.data} />;
  }

  if (query.isLoading) {
    return <ReviewableTemplatePlaceholder isLoading />;
  }

  return (
    <SiteContainer width="md">
      {query.error instanceof ApiError && query.error?.status === 404 ? (
        <ArtistNotFound type="artist" linkText="Explore" linkTo="/search">
          You can find more artists on the Explore page, try searching or
          applying filters to find what you&apos;re looking for.
        </ArtistNotFound>
      ) : (
        "Sorry, we had a problem loading that resource."
      )}
    </SiteContainer>
  );
}

export default ArtistProfile;
